import { Box, TextField, Typography } from "@mui/material";
import React from "react";

interface MobileInputPropTypes {
  formik: any;
  title: string;
  placeholder: string;
  disabled?: boolean;
  handleSubmit?: () => void;
}

const LoginInputField: React.FC<MobileInputPropTypes> = ({ formik,title,placeholder,disabled=false,handleSubmit }: MobileInputPropTypes) => {
  const inputProps = {
    value: formik.values.loginInput,
    onChange: formik.handleChange,
    error: formik.touched.loginInput && Boolean(formik.errors.loginInput),
    helperText: formik.touched.loginInput && formik.errors.loginInput,
  };

  return (
    <Box>
      <Typography color="text.primary" mb={0.5}>
        {title}*
      </Typography>
      <TextField
        value={inputProps.value}
        onChange={inputProps.onChange}
        name="loginInput"
        fullWidth
        placeholder={placeholder}
        error={inputProps.error}
        disabled={disabled}
        helperText={inputProps.helperText}
        slotProps={{
          input: { sx: { bgcolor: "#ffffff" } },
        }}
        onKeyDown= {(e) => {
          if (e.key === "Enter" && !disabled  &&  handleSubmit) {
            handleSubmit();
          }
        }}

      />
    </Box>
  );
};

export default LoginInputField;
